






























import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';

@Component
export default class CarouselSource extends Vue {
  @Prop({ default: '.carousel-source' })
  private readonly selector!: string;

  @Prop({ default: 0 })
  private readonly interval!: number;

  @Prop({ default: false })
  private readonly attachClick!: boolean;

  @Prop({ default: false })
  private readonly watchLocation!: boolean;

  private images: Array<HTMLElement> = [];
  private slide = 0;

  mounted () {
    this.images = Array.from(document.querySelectorAll(this.selector));
    if (false !== this.attachClick) { // prop is not true without value
      for (const img of this.images) {
        img.addEventListener('click', this.onThumbClick);
      }
    }

    if (false !== this.watchLocation) { // prop is not true without value
      addEventListener('hashchange', this.onHashChange);
      Vue.nextTick(this.slideToHash);
    }
  }

  onThumbClick (event: Event) {
    const idx = this.images.indexOf(event.target as HTMLElement);
    if (idx > -1) this.slide = idx;
    if (this.interval) this.$el.scrollIntoView({
      behavior: 'smooth'
    }); // see onSlideStart
  }

  onHashChange(event: HashChangeEvent) {
    this.slideToHash();
  }

  onSlideStart(slide: number) {
    if (false !== this.watchLocation) { // prop is not true without value
      window.location.hash = '#' + (slide + 1);
    }
    if (!this.interval) this.$el.scrollIntoView({
      behavior: 'smooth'
    });
  }

  slideToHash() {
    const newHash = '' + window.location.hash.split('#').pop();
    const idx = parseInt(newHash) - 1;
    if (idx > -1) this.slide = idx;
  }
}
